import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.87161 2.83221C8.05634 3.03746 8.0397 3.35361 7.83444 3.53834L6.58072 4.66669L7.83444 5.79504C8.0397 5.97977 8.05634 6.29592 7.87161 6.50117C7.68688 6.70643 7.37073 6.72307 7.16548 6.53834L5.49881 5.03834C5.39345 4.94352 5.33329 4.80843 5.33329 4.66669C5.33329 4.52495 5.39345 4.38987 5.49881 4.29504L7.16548 2.79504C7.37073 2.61031 7.68688 2.62695 7.87161 2.83221Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99996 4.66669C5.99996 4.39055 6.22382 4.16669 6.49996 4.16669H8.83329C11.3186 4.16669 13.3333 6.18141 13.3333 8.66669V8.83336C13.3333 9.1095 13.1094 9.33336 12.8333 9.33336C12.5572 9.33336 12.3333 9.1095 12.3333 8.83336V8.66669C12.3333 6.73369 10.7663 5.16669 8.83329 5.16669H6.49996C6.22382 5.16669 5.99996 4.94283 5.99996 4.66669Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.12831 9.49888C8.31304 9.29362 8.62919 9.27698 8.83444 9.46171L10.5011 10.9617C10.6065 11.0565 10.6666 11.1916 10.6666 11.3334C10.6666 11.4751 10.6065 11.6102 10.5011 11.705L8.83444 13.205C8.62919 13.3897 8.31304 13.3731 8.12831 13.1678C7.94358 12.9626 7.96022 12.6464 8.16548 12.4617L9.4192 11.3334L8.16548 10.205C7.96022 10.0203 7.94358 9.70413 8.12831 9.49888Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.16663 6.66669C3.44277 6.66669 3.66663 6.89055 3.66663 7.16669V7.33336C3.66663 9.26635 5.23363 10.8334 7.16663 10.8334H9.49996C9.7761 10.8334 9.99996 11.0572 9.99996 11.3334C9.99996 11.6095 9.7761 11.8334 9.49996 11.8334H7.16663C4.68134 11.8334 2.66663 9.81863 2.66663 7.33336V7.16669C2.66663 6.89055 2.89048 6.66669 3.16663 6.66669Z"
      fill="currentColor"
    />
  </SvgIcon>
));
